<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/zepto.png" /></div>
      <p>Zepto</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = 'https://uedcdn.zto.com/static/zepto/'
export default {
  name: 'index',
  data () {
    return {
      fileList: [{
        label: '1.2.0',
        linkList: [
          ur + '1.2.0/zepto.js',
          ur + '1.2.0/zepto.min.js'
        ]
      }, {
        label: '1.1.7',
        linkList: [
          ur + '1.1.7/zepto.js',
          ur + '1.1.7/zepto.min.js'
        ]
      }, {
        label: '1.1.6',
        linkList: [
          ur + '1.1.6/zepto.js',
          ur + '1.1.6/zepto.min.js'
        ]
      }, {
        label: '1.1.5',
        linkList: [
          ur + '1.1.5/zepto.js',
          ur + '1.1.5/zepto.min.js'
        ]
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/ListZepto.vue